// Faz BO (2026-05-10) — JWT permissions helpers (Layout.js'den çıkarıldı)
// Eskiden Layout.js içinde private helper'dı; sidebar refaktörüyle paylaşılır
// modül haline geldi (yeni Sidebar + AppShell + ileri PR'lar buradan tüketir).

export function getUserPermissions() {
  const token = typeof window !== "undefined" ? window.localStorage.getItem("token") : null;
  if (!token) return { full: true, perms: [] };
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const perms = Array.isArray(payload.permissions) ? payload.permissions : [];
    const isFull = perms.includes("admin.full") || perms.length === 0;
    return { full: isFull, perms };
  } catch {
    return { full: true, perms: [] };
  }
}

// Path → permission key. Yeni sayfa eklendiğinde buraya da ekle.
const PATH_PERMISSIONS = {
  "/cockpit": "page.cockpit",
  "/dashboard": "page.dashboard",
  "/dashboard-v2": "page.dashboard",
  "/notes": "page.notes",
  "/action-center": "page.action_center",
  "/site-traffic": "page.site_traffic",
  "/geo": "page.geo",
  "/journey": "page.journey",
  "/reports": "page.reports",
  "/categories": "page.categories",
  "/products": "page.products",
  "/product360": "page.product360",
  "/orders": "page.orders",
  "/subscriptions": "page.subscriptions",
  "/users": "page.users",
  "/suppliers": "page.suppliers",
  "/email-campaign": "page.email_campaign",
  "/email-performance": "page.email_perf",
  "/whatsapp": "page.whatsapp",
  "/drip-builder": "page.drip",
  "/pazar-analizi": "page.pazar_analizi",
  "/marketing": "page.marketing",
  "/settings": "page.settings",
  "/system-health": "page.system_health",
  "/stock": "page.stock",
  "/b2b-pricing": "page.b2b_pricing",
  "/quotes": "page.quotes",
  "/cari-hesap": "page.cari",
  "/push-campaigns": "page.push",
  "/campaigns": "page.campaigns",
  "/import-export": "page.import_export",
  "/integrations": "page.integrations",
  "/audit-log": "page.audit_log",
  "/abandoned-cart": "page.abandoned_cart",
  "/welcome-email": "page.welcome_email",
  "/pending": "page.pending_users",
  "/nps": "page.nps",
  "/coupons": "page.coupons",
  "/rfm": "page.rfm",
  "/silent-customers": "page.rfm",
  "/cohort": "page.cohort",
  "/cross-sell": "page.cross_sell",
  "/funnel": "page.funnel",
  "/recommendations": "page.recommendations",
  "/forecast": "page.forecast",
  "/sales-pattern": "page.sales_pattern",
  "/category-sales": "page.category_sales",
  "/monthly-goals": "page.monthly_goals",
  "/reviews": "page.reviews",
  "/returns": "page.returns",
  "/admin-users": "admin.users.manage",
  "/bulk-import": "page.users",
  "/bulk-product-import": "page.products",
  "/stock-adjustments": "page.stock",
};

export function permissionForPath(path) {
  return PATH_PERMISSIONS[path] || null;
}

export function canAccessPath(userPerms, path) {
  if (userPerms.full) return true;
  const required = permissionForPath(path);
  if (!required) return true;
  return userPerms.perms.includes(required);
}
